/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

export interface IAdressDropdown {
    id: string;
    name: string;
    className: string;
    value: string | number;
    additionalAddributes?: object;
    displayData: { key?: string | number; value?: string }[];
    onChange(event: React.ChangeEvent<HTMLSelectElement>): void;
}

const getDropdownItem = (key?: string | number, value?: string, selectedValue?: string | number): React.ReactNode => {
    let isSelected: boolean;
    if (typeof key === 'number') {
        isSelected = key === selectedValue;
    } else {
        isSelected = typeof selectedValue === 'string' && (key || '').toLowerCase() === (selectedValue || '').toLowerCase();
    }

    return (
        <option key={key} value={key} aria-selected={isSelected}>
            {value}
        </option>
    );
};

/**
 * Address dropdown.
 * @param props - Configuration of the functional component.
 * @returns React functional component.
 */
export const AddressDropdownFunctionComponent: React.FC<IAdressDropdown> = (props: IAdressDropdown) => {
    const { id: itemId, className, value, additionalAddributes, displayData, onChange } = props;

    //CUSTOM
    let disabled = true;
    let tabIndex = 0;
    let onClick = (e: React.MouseEvent<HTMLSelectElement> | React.KeyboardEvent<HTMLSelectElement>) => {};
    if (itemId === 'shipping_addressthreeletterisoregionname') {
        disabled = false;
        tabIndex = -1;
        onClick = (e: React.MouseEvent<HTMLSelectElement> | React.KeyboardEvent<HTMLSelectElement>) => {
            const keyboardEvent = e as React.KeyboardEvent<HTMLSelectElement>;
            if (e.type === 'mousedown' || (e.type === 'keydown' && keyboardEvent.which !== 9)) {
                e.preventDefault();
                e.stopPropagation();
            }
        };
    }
    //--CUSTOM

    return (
        <select
            id={itemId}
            className={`${className}__dropdown`}
            name={'input-field'}
            value={value}
            disabled={disabled} // VSI - Customization //CUSTOM
            onChange={onChange}
            tabIndex={tabIndex} //CUSTOM
            onMouseDown={onClick} //CUSTOM
            onKeyDown={onClick} //CUSTOM
            autoComplete='off'
            aria-autocomplete='none'
            {...(additionalAddributes || {})}
        >
            {displayData && displayData.map(item => getDropdownItem(item.key, item.value, value))}
        </select>
    );
};

export default AddressDropdownFunctionComponent;
